"use strict";

// The place for custom javacript / jQuery
jQuery(document).ready(function ($) {
  var root = $('body');
  var popup = $('.popup-container');
  var lastScrollTop = 0;
  var headerOffset = 0;
  var headerScrollOffset = 30;

  $(window).on("load", function (e) {
    hashCheck();
    timelineHandler();
  });


  $('body').removeClass('preload');
  var path = 'https://www.kaasmuseum.nl/wp-content/themes/raadhuis/assets/animations/';

  if (location.hostname === "localhost") {
    var path = 'assets/animations/';
  }

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homnl'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas.json'
    });
  }, 1300);


  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homes'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-es.json'
    });
  }, 1300);

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homen'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-en.json'
    });
  }, 1300);

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homde'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-de.json'
    });
  }, 1300);

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homfr'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-fr.json'
    });
  }, 1300);

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('homzh-cn'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-ch.json'
    });
  }, 1300);

  setTimeout(() => {
    var animation = bodymovin.loadAnimation({
      // animationData: { /* ... */ },
      container: document.getElementById('hom'), // required
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: path + 'keeskaas-ch.json'
    });
  }, 1300);

  setTimeout(function () {
    root.removeClass('loading');
  }, 500);

  $(window).scroll(function () {
    var pageTop = $(document).scrollTop();

    // Slide out navbar
    if (pageTop > lastScrollTop) {
      if (pageTop > headerScrollOffset) {
        root.addClass('scrolldown');
        root.removeClass('scrollup');
        root.removeClass('on-top');
      }
    } else {

      if (pageTop > headerScrollOffset) {
        root.addClass('scrollup');
        root.removeClass('scrolldown');
        root.removeClass('on-top');
      }
    }

    if (pageTop == headerOffset) {
      root.removeClass('scrolldown');
      root.removeClass('scrollup');
      root.addClass('on-top');
    }

    lastScrollTop = pageTop;
  });

  $('#hamburger').click(function () {
    $(this).toggleClass('active');
    $('#nav-mobile').toggleClass('active');
    $('body').toggleClass('overflow');
  });

  // $('.languages').hover(function() {
  //   $('.languages ul').toggleClass('active');
  // });

  $("[data-form-trigger]").on('click', function () {
    var formTrigger = $(this).data('form-trigger');

    // Reset values on form switch
    $('.calc').text('');
    $('#user-without-adults, #user-with-adults').val('');
    $('#user-without-children, #user-with-children').val('');

    $("[data-form-trigger]").removeClass('active');
    $('.content-switch').fadeOut('fast');
    $(this).addClass('active');
    $('.content-switch#' + formTrigger).fadeIn('fast');
  });

  $('.tooltip').on('click', function () {
    $(this).toggleClass('active');
  });

  $('.popup-trigger').on('click', function () {
    var trigger = $(this).data('popup-trigger');

    $('#hamburger').removeClass('active');
    $('#nav-mobile').removeClass('active');

    // Change video ID
    if ($(this).hasClass('popup-video-trigger')) {

      var videoID = $(this).data('video-id');
      var youtubeSrc = 'https://www.youtube-nocookie.com/embed/' + videoID + '?enablejsapi=1&version=3&playerapiid=ytplayer&rel=0&modestbranding=1&showinfo=0&rel=0&cc_load_policy=1'
      $('.popup-container').find('iframe').attr('src', youtubeSrc);


      setTimeout(function () {
        $('.popup-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      }, 800);
    }

    if ($(this).hasClass('popup-search-trigger')) {
      setTimeout(function () {
        $('input#zoekveld').focus()
      }, 800);
    }

    // Made visible
    $('.popup-container.' + trigger).addClass('active');
    root.addClass('overflow');
  });

  // Click background to close
  $('.popup-bg').on('click', function (e) {
    if ($(popup).hasClass('popup-video')) {
      $('.popup-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }
    popup.removeClass('active');
    root.removeClass('overflow');
  });

  // Click close button to close
  $('.popup-close').on('click', function () {
    if ($(popup).hasClass('popup-video')) {
      $('.popup-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }
    popup.removeClass('active');
    root.removeClass('overflow');
  });

  // Press escape key to close
  $(document).keydown(function (e) {
    if (e.keyCode == 27) {
      if ($(popup).hasClass('popup-video')) {
        $('.popup-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      }
      popup.removeClass('active');
      root.removeClass('overflow');
    }
  });

  $('.timeline-container .number').on('click', function () {
    var number = $(this).data('line-toggle');
    $('.timeline-container .number').removeClass('active')
    $(this).addClass('active')

    $('.timeline-content').removeClass('active');
    $('#timeline-' + number).addClass('active');
  });

  function timelineHandler() {

    // Handle bullet timeline
    $('.timeline-container .number').on('click', function () {
      var number = $(this).data('line-toggle');
      $('.timeline-container .number').removeClass('active')
      $(this).addClass('active')

      $('.timeline-content').removeClass('active');
      $('#timeline-' + number).addClass('active');

      scrollToContent();
    });

    $('.timeline-nostalgie .timeline-content').on('click', function () {
      var timelineFullID = $(this).attr('id');
      var timelineID = timelineFullID.split('-').pop();

      // Change active number
      $('.timeline-container .number').removeClass('active');
      $('[data-line-toggle="' + timelineID + '"]').addClass('active');

      $('.timeline-container .timeline-content').removeClass('active');
      $(this).addClass('active');

      scrollToContent();
    });

    $(document).on('click', '.next-step', function () {
      var activeID = $('.number.active').data('line-toggle');
      var nextID = activeID + 1;

      // Change active number
      $('.number').removeClass('active');
      $('[data-line-toggle="' + nextID + '"]').click();

      scrollToContent();
    });

    function scrollToContent() {
      $('html,body').animate({
        scrollTop: $(".timeline-grid").offset().top - 180
      }, 'slow');
    }
  }

  $('.content, .wpcf7-response-output').click(function () {
    var message = $('.wpcf7-response-output');

    if (message.is(':visible')) {
      message.slideUp('fast');
    }
  });

  // Faq
  $('.faq-question h5, .faq-icon').click(function (e) {
    e.preventDefault();
    $('.faq-extended').stop();

    var parent = $(this).closest('.faq-item');

    if (parent.hasClass('active')) {
      parent.find('.faq-extended').slideUp(300);
      parent.removeClass('active').addClass('slide-up');
      setTimeout(function () {
        parent.removeClass('slide-up');
      }, 300);
    } else {
      $('.faq-extended').slideUp(300);
      $('.faq-item').removeClass('active');
      parent.find('.faq-extended').slideDown(300);
      parent.addClass('active');
    }
  });

  // Initial load
  $('.faq-extended').slideUp(300);
  $('.faq-item').removeClass('active');

  // Fade elements in if in viewport
  $(window).on("load resize scroll", function (e) {

    // Fade in elements when in viewport
    $(".column, .circle, .element, #home-details").each(function (i, element) {
      var $element = $(element);
      if ($element.visible(true)) {
        $element.addClass("in-viewport");
      }
    });
  });

  function startCounting() {
    $('.counter').each(function () {
      var $this = $(this),
        countTo = $this.attr('data-count');

      $({
        countNum: $this.text()
      }).animate({
        countNum: countTo
      }, {
        duration: 2000,
        easing: 'swing',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
        }
      });
    });
  }

  function checkForChanges() {
    if ($('#home-details').hasClass('in-viewport')) {
      startCounting();
    } else {
      setTimeout(checkForChanges, 500);
    }
  }

  checkForChanges();

  function hashCheck() {

    if (window.location.hash) {
      var hash = true
      var hashValHash = window.location.hash;
      var hashValClean = hashValHash.substring(1); //Puts hash in variable, and removes the # character

      if (hash) {
        $('html, body').animate({
          'scrollTop': $(hashValHash).offset().top - 150
        }, 100);

        // Reset
        hash = false;
      }
    }
  }

  $('.popup-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: 'Image could not be loaded...',
    }
  });

  // Datepicker
  var dateToday = new Date();
  var dates = $("#user-without-date, #user-with-date").datepicker({
    defaultDate: "+1w",
    changeMonth: true,
    numberOfMonths: 1,
    minDate: dateToday,
    onSelect: function (selectedDate) {
      var option = this.id == "from" ? "minDate" : "maxDate",
        instance = $(this).data("datepicker"),
        date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
      dates.not(this).datepicker("option", option, date);
    }
  });

  // End document ready
});